import CategoryItem from './CategoryItem/CategoryItem';
import { twJoin } from 'tailwind-merge';
import { FilterOptionsUrlQueryType } from 'types/productFilter';

export type SubCategoryType = {
    slug: string;
    link: string | null;
    image: string | null;
    name: string;
    productsCount: number;
};

export type CategorySubcategoriesProps = {
    listedItems: SubCategoryType[];
    filter?: FilterOptionsUrlQueryType;
    displayProductCount?: boolean;
    className?: string;
    itemClassName?: string;
};

const CategorySubcategories: FC<CategorySubcategoriesProps> = ({
    listedItems,
    displayProductCount,
    filter,
    className,
    itemClassName,
}) => {
    if (listedItems.length > 0) {
        return (
            <ul className={twJoin('-mx-1 mb-7 flex flex-row flex-wrap p-0 md:-mr-1', className)}>
                {listedItems.map((listedItem, key) => (
                    <CategoryItem
                        className={itemClassName}
                        key={key}
                        listedItem={listedItem}
                        isSubcategory
                        filter={filter}
                        displayProductCount={displayProductCount}
                    />
                ))}
            </ul>
        );
    }

    return null;
};

export default CategorySubcategories;
